import { IClientValidator } from "./IClientValidator.js";

    /// Works with PaymentTypeAttribute.cs to perform unobtrusive validation in MVC against payment type input elements.
    /// Used by the checkout/payment page.
    export class PaymentType implements IClientValidator {
        public validate(value: string, element: HTMLInputElement, params: any): boolean {
            let paymentFieldIds = params.paymentfieldids.split(",");

            for (const paymentFieldId of paymentFieldIds) {
                let paymentField = <HTMLInputElement>document.getElementById(paymentFieldId);

                if (paymentField && paymentField.checked) {
                    return true;
                }
            }

            return false;
        }
    }

window.validators = window.validators || {};
window.validators.paymenttype = new PaymentType();
